/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-var: 0 */
/* globals _, hex_md5, mp */

/*
 * Provides:
 *  mp.api.middleware.CallbackManager
 *
 * Requires:
 *  mp.api.Middleware
 *  mp.api.middleware.Cache
 *  md5.js
 */

_.namespace(`mp.api.middleware`, function() {
  'use strict';

  function CallbackManager() {}
  _.inherit(CallbackManager, mp.api.Middleware);

  CallbackManager.prototype._api_init = function(api, api_config) {
    CallbackManager.superclass._api_init.apply(this, arguments);

    _.each(this.api._middleware, function(m) {
      if (m instanceof mp.api.middleware.Cache) {
        this.cache_middleware = m;
      }
    }, this);
  };

  CallbackManager.prototype.reset = function() {
    this.callbacks = {};
    this.jqxhrs = {};
  };

  CallbackManager.prototype._generate_cache_key = function(request) {
    if (this.cache_middleware) { return this.cache_middleware._generate_cache_key(request); }
    var data = request.endpoint + JSON.stringify(request.params);
    return hex_md5(data);
  };


  CallbackManager.prototype.on_request = function(request, next) {
    if (!request.callback_key) { request.callback_key = this._generate_cache_key(request); }

    if (_.has(this.callbacks, request.callback_key)) {
      this.callbacks[request.callback_key].push(request);
      return this.jqxhrs[request.callback_key];
    } else {
      this.callbacks[request.callback_key] = [];
      var jqxhr = next(request);
      this.jqxhrs[request.callback_key] = jqxhr;
      return jqxhr;
    }
  };

  CallbackManager.prototype.on_response = function(request, response, next) {
    if (!request.callback_key) { request.callback_key = this._generate_cache_key(request); }

    if (_.has(this.callbacks, request.callback_key)) {
      var callbacks = this.callbacks[request.callback_key];
      delete this.callbacks[request.callback_key];

      _.each(callbacks, function(req) {
        if (req.callback) {
          req.callback(response, request);
        }
      });
    }

    return next(request, response);
  };

  return {
    CallbackManager,
  };

});

}.call(window));